import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles({
  root: {
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  icon: {
    borderRadius: "50%",
    width: 20,
    height: 20,
    border: "1px solid #C4C4C4",
  },
  checkedIcon: {
    border: "2px solid #0DD1C5",
    "&:before": {
      display: "block",
      width: 16,
      height: 16,
      backgroundImage: "radial-gradient(#0DD1C5,#0DD1C5 45%,transparent 50%)",
      content: '""',
    },
  },
  label: {
    color: "red",
  },
});
